import React, { useState, useEffect, Fragment } from "react";
import Divider from "@mui/material/Divider";
import { useForm, Controller } from "react-hook-form";
import Dialog from "@mui/material/Dialog";
import InputLabel from "@mui/material/InputLabel";

import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";
import ReactDOM from "react-dom";

import axios from "../../../../api/axios";

import {
  Typography,
  Box,
  Paper,
  Link,
  Grid,
  Radio,
  Select,
  Button,
  TextField,
  Checkbox,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";

import "../Operations.css";
import { useLocation } from "react-router-dom";
import { url } from "../../../../configlink";

export default function ACGTCardEdit() {
  const [acgtCardId, setAcgtCardId] = useState(0);
  const [acgtCardNumber, setAcgtCardNumber] = useState("");
  const [pin, setPin] = useState("");
  const [activated, setActivated] = useState(false);
  const [corporateName, setCorporateName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [email, setEmail] = useState("");

  let loc = useLocation();
  let [acgtcardData, setACGTCardData] = useState([]);

  useEffect(() => {
    let data = loc.search.split("=")[1];
    console.log(data);
    getAcgtcardDetals(data);
  }, []);

  async function getAcgtcardDetals(x) {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_admin_acgtcard_edit_detail`,
        {
          params: {
            id: x,
          },
          withCredentials: true,
        }
      );
      console.log(response.data);
      let card = response.data[0];
      setACGTCardData(card);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (acgtcardData) {
      console.log("data", acgtcardData);

      setAcgtCardId(acgtcardData.id);
      setActivated(acgtcardData.activate_status === 1 ? true : false);
      setAcgtCardNumber(acgtcardData.CardNumber);
      setPin(acgtcardData.pinnumber);
      setCorporateName(acgtcardData.CorporateName);
      setFirstName(acgtcardData.FirstName);
      setLastName(acgtcardData.LastName);
      setPhone(acgtcardData.PhoneNumber);
      setBillingAddress(acgtcardData.BillingAddress);
      setShippingAddress(acgtcardData.ShippingAddress);
      setEmail(acgtcardData.EmailAddress);
    }
  }, [acgtcardData]);

  const handleChange = (x) => {
    setActivated(x);
  };

  const submitForm = async (data) => {
    let res = await fetch(
      `${url}/api/admin/post_update_acgtcarddetail_data`,
      {
        method: "post",
        body: JSON.stringify({
          acgtCardId: acgtCardId,
          acgtCardNumber: acgtCardNumber,
          pin: pin,
          activated: activated,
        }),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include'
      }
    );
  };

  return (
    <FormControl>
      <div style={{ padding: 20, paddingBottom: 30, margin: "auto" }}>
        <Typography
          variant="h5"
          style={{ fontWeight: "bold", color: "var(--color-primary-purple)" }}
          align="Center"
        >
          Edit ACGT Card
        </Typography>
        <Divider style={{ marginTop: 10, marginBottom: 30 }} />

        <Box style={{ padding: 16, border: "0px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="acgtCardId"
                value={`${acgtCardId} (Automatically Assigned)`}
                fullWidth
                type="text"
                label="ACGT Card ID"
                style={{
                  color: "black",
                  pointerEvents: "none", // not editable
                }}
              />
            </Grid>

            <Box display="flex" alignItems="center" padding={2}>
              <Checkbox
                checked={activated}
                onChange={(e) => handleChange(e.target.checked)}
              />
              <Typography variant="body1">Activated</Typography>
            </Box>

            <Grid item xs={12}>
              <TextField
                name="acgtCardNumber"
                value={acgtCardNumber}
                fullWidth
                required
                type="text"
                label="ACGT Card #"
                onChange={(e) => setAcgtCardNumber(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                name="pin"
                value={pin}
                fullWidth
                required
                type="text"
                label="Pin Number"
                onChange={(e) => setPin(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                value={corporateName}
                required
                name="corporateName"
                type="text"
                label="Corporate Name"
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                value={lastName}
                required
                name="lastName"
                type="text"
                label="LastName"
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                value={firstName}
                required
                name="firstName"
                type="text"
                label="FirstName"
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                value={email}
                name="email"
                fullWidth
                type="text"
                label="Email Address"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={phone}
                name="phone"
                fullWidth
                type="text"
                label="Phone Number"
                onChange={(e) => setPhone(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                multiline
                rows={3}
                value={billingAddress}
                name="billingAddress"
                fullWidth
                type="text"
                label="Billing Address"
                onChange={(e) => setBillingAddress(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                multiline
                rows={3}
                value={shippingAddress}
                name="shippingAddress"
                fullWidth
                type="text"
                label="Shipping Address"
                onChange={(e) => setBillingAddress(e.target.value)}
              />
            </Grid>
            <Grid
              item
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginTop: 20,
              }}
            >
              <Grid item>
                <Button
                  type="button"
                  variant="contained"
                  style={{
                    textTransform: "none",
                    color: "white",
                    backgroundColor: "var(--color-primary-purple)",
                  }}
                  onClick={submitForm}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Divider style={{ marginTop: 50 }} />

        <Grid
          item
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: 30,
          }}
        >
          <Grid item>
            <Button
              type="button"
              style={{
                textTransform: "none",
                width: "150px",
                color: "white",
                fontSize: 12,
                backgroundColor: "var(--color-primary-purple)",
              }}
              onClick={() => window.close()}
            >
              Close Window
            </Button>
          </Grid>
        </Grid>
      </div>
    </FormControl>
  );
}
